import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  zonesList: [],
  status: 'idle',
  error: null,
};

const zonesListSlice = createSlice({
  name: 'zonesList',
  initialState,
  reducers: {
    setZonesList: (state, action) => {
      state.zonesList = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});
export const { setZonesList, setError, setLoading } = zonesListSlice.actions;
export default zonesListSlice.reducer;
